<div class="px-[20px]">
	<div *ngIf="isMobile || currentView == 2" class="w-full text-[24px] text-black font-bold"
		 [ngClass]="isMobile ? 'justify-center flex':''">
		Setup your User PIN
	</div>
	<ng-container>
		<ng-container>
			<ng-container [ngSwitch]="currentView">
				<div *ngSwitchCase="1" class="m-t-24">
					<app-set-business-pin-modal
						[dismissible]="dismissible"
						[isLoading]="triggeringOtp"
						(pinToUse)="updatePinToUse($event)"
						[isBusinessPinBlocked]="userPinDetails?.isBusinessPinBlocked"
						[isUserBo]="userPinDetails?.userIsBo"
						[userPinDetails]="userPinDetails"
						[totalBusinesses]="userPinDetails?.totalBusinesses"
						[isModal]="isModal" (submitEvent)="nextStep()"
						[hideUseBusinessPin]="hideUseBusinessPin"
						(onBackEvent)="back()"></app-set-business-pin-modal>
				</div>
				<div *ngSwitchCase="1" class="m-t-24">

				</div>
				<div *ngSwitchCase="2" class="m-t-24">
					<ng-container *ngIf="!triggeringOtp, else loading">
						<ng-container *ngIf="!otpError, else error">
							<div>
								<p class="page-header" style="margin-bottom: 16px;">Verify your Phone Number</p>
							</div>
							<div>
								<p class="text-sm" style="color: rgba(0, 0, 0, 0.9); margin-top: 8px;">
									{{otpTriggerResponse.otpMessage}}
								</p>
							</div>
							<form [formGroup]="otpForm">
								<div>
									<app-floating-label-input [controlDef]="otpControl" iconPosition="right" label="PIN"
															  placeHolder="Enter OTP">
									</app-floating-label-input>
									<div nz-row nzJustify="end"
										 style="margin-top: -24px; font-weight: 600;"
										 [ngClass]="otpForm.value.otp?.length === 6 ? 'text-primary' : 'text-[#cccccc]'">
										<p class="text-sm mb-0">{{otpForm.value.otp?.length ? otpForm.value.otp?.length
											:
											'0'}}/6</p>
									</div>
								</div>
								<div class="otp-resend flex flex-row">
									<div class="grow-0">
										<span>
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
												 xmlns="http://www.w3.org/2000/svg">
												<path
													d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
													fill="#0361F0"/>
											</svg>
										</span>
									</div>
									<div class="grow pl-2 flex items-center">
										<span class="alert-info">
											Didn’t get the code? Dial
											<a [href]="'tel:' + otpTriggerResponse.ussdCode"><span
												class="fw-bold text-primary">{{otpTriggerResponse.ussdCode}}</span></a>
										</span>
									</div>
								</div>
								<div>
									<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
								</div>
								<div nz-row nzJustify="end" class="m-t-10">
									<button class="bare-button text-primary m-r-24" (click)="backStep(1)">Back</button>
									<app-custom-submit-button [submitting]="validating||submittingUserPin" name="Next"
															  (submitForm)="submit()">
									</app-custom-submit-button>
								</div>
							</form>
						</ng-container>
					</ng-container>

				</div>
				<div *ngSwitchCase="3">
					<div class="w-full text-[12px] text-[#000000]/60 m-t-8">
						This PIN is to be used to authorize transactions (e.g. transfers, airtime purchases, bill
						payments,
						etc.)
					</div>
					<div class="m-t-8">
						<form>
							<div class="">
								<div class="text-bold py-[8px]">Create User PIN</div>
								<div class="border border-[#0357EE]/10] p-[10px] text-center rounded-[8px]">
									<app-password-input-box id="oldPin" [design]="'NEW'" [noOfPin]="4"
															(emitInput)="setPin($event)"></app-password-input-box>
								</div>
							</div>
						</form>
						<form>
							<div class="">
								<div class="text-bold py-[8px]">Confirm User PIN</div>
								<div class="border border-[#0357EE]/10] p-[10px] text-center rounded-[8px]">
									<app-password-input-box [id]="'confirmPin'" [design]="'NEW'" [noOfPin]="4"
															(emitInput)="setConfirmPin($event)">
									</app-password-input-box>
								</div>
							</div>
						</form>
						<div *ngIf="pinTypeToUse===3" class="checkbox pt-3 text-[14px] text-bold">
							<label nz-checkbox [(ngModel)]="checked">
								Use User PIN to <b>Unblock</b> your Business PIN
							</label>
						</div>


					</div>
					<div class="flex flex-row mt-[12px] rounded-[8px] p-[12px] bg-[#E94444]/10" *ngIf="!isValidPin">
						<div class="flex-shrink pr-[8px]">
                            <span nz-icon nzType="exclamation-circle" nzTheme="fill"
								  style="font-size: 16px; color: red;"></span>
						</div>
						<div class="text-black">
							The PINs you entered do not match.
							Please try again.
						</div>
					</div>

					<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>

					<div nz-row class="mt-[40%]" nzJustify="space-between">
						<div nz-col nzSpan="11">
							<app-custom-button [isDisabled]="submitted" [isBlock]="true" state="secondary" text="Back"
											   (click)="backStep(2)">
							</app-custom-button>
						</div>
						<div nz-col nzSpan="11">
							<app-custom-button [isSubmitting]="submitted" [isBlock]="true" state="primary"
											   text="Confirm" (click)="onSubmitEvent()"
											   [isDisabled]="form.invalid || (form.value.newPin !== form.value.confirmPin)">
							</app-custom-button>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #error>

		<app-custom-error-display [errorMessage]="otpError"></app-custom-error-display>
		<div nz-row nzJustify="end" style="margin-top: 40px">
			<button class="bare-button text-primary m-r-24" (click)="cancel()">Cancel</button>
			<app-custom-submit-button name="Retry OTP" (submitForm)="triggerOtp()"></app-custom-submit-button>
		</div>

	</ng-template>

	<ng-template #loading>
		<app-loading [loadingText]="'Please wait...'"></app-loading>
	</ng-template>

	<ng-template #success>
		<nz-modal [(nzVisible)]="isMobile" [nzTitle]="null" [nzContent]="success" [nzFooter]="null" [nzClosable]="false"
				  [nzCentered]="true"
				  [nzStyle]="{ padding: '0', margin: '0', maxWidth: '100%', width: '100vw', height: '100vh'}"
				  [nzBodyStyle]="{ padding: '0', height: '100vh', width: '100vw'}" [nzMaskClosable]="false"
				  [nzMask]="false">
			<ng-template #success>
				<app-kamona-maximize-mobile-dialog *ngIf="isMobile" (emitAction)="closeSuccessModal()"
												   [buttonName]="'Dismiss'" [description]="mobileModalDesc"
												   [mobileMessageType]="messageType"
												   [title]="mobileModalTitle">
				</app-kamona-maximize-mobile-dialog>
			</ng-template>
		</nz-modal>
	</ng-template>

</div>
